import { render, staticRenderFns } from "./LittleGateDamageSeverity.vue?vue&type=template&id=60e33fe7&scoped=true"
import script from "./LittleGateDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./LittleGateDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e33fe7",
  null
  
)

export default component.exports